import { Resource } from "i18next";
import t from "../../locales/pt.json";

export default t as Resource;
